import { env } from 'config';
import { AutomationSource, PaginatedData, QueryParams } from 'types';
import { apiUtils } from 'utils';

import { createCrudApi } from './crud.api';

const url = `${env.apiUrl}/automation-sources`;

const getAllPaginatedByTradeMethodId =
  (id: string) =>
  async (params?: QueryParams): Promise<PaginatedData<AutomationSource>> =>
    (await apiUtils.getWithQueryParams(`${url}/trade-method/${id}`, params))
      .data;

export const automationSourcesApi = {
  ...createCrudApi<AutomationSource>('/automation-sources'),
  getAllPaginatedByTradeMethodId,
};
